import React, { memo, useState, useContext, useEffect, useRef } from "react";

import { Box } from "@mui/material";

import BarraTablas from "../../../components/BarraTablas/BarraTablas";
import Tabla from "./Componentes/Tabla";
import Modal from "./Componentes/Modal";
import ModalB from "./Componentes/ModalB";
import AuthContext from "../../../Context/Auth/AuthContext";
import clienteAxios from "../../../config/axios";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
import io from "socket.io-client";
import { socketUrl } from "../../../config/const";
import { SocketProvider } from "../../../Context/WhatsappSocket/SocketContext";
const Asistencia = (props) => {
  const {
    idmascota,
    settab,
    setarrayExportHijos,
    desdeOtroLugarMascota,
    // puedeExportar,
    // itemRelacionadoPadre,
  } = props;
  // DATA DEL STATE
  useEffect(() => {
    if (desdeOtroLugarMascota) {
      settab("");
      setarrayExportHijos(arrayExport.map((item) => item[campoExport]));
    }
    // eslint-disable-next-line
  }, [arrayExport]);
  const [rows, setrows] = useState(null);
  const columns = [
    {
      id: "empRuc",
      label: "Ruc",
      minWidth: 150,
      tipo: "string",
      propiedad: "empRuc",
    },
    {
      id: "empNombre",
      label: "Nombre",
      minWidth: 150,
      tipo: "string",
      propiedad: "empNombre",
    },
    {
      id: "empRepresentante",
      label: "Representante",
      minWidth: 150,
      tipo: "string",
      propiedad: "empRepresentante",
    },
    {
      id: "empComercial",
      label: "Comercial",
      minWidth: 150,
      tipo: "string",
      propiedad: "empComercial",
    },
    {
      id: "empObligado",
      label: "Obligado",
      minWidth: 150,
      tipo: "string",
      propiedad: "empObligado",
    },
    {
      id: "empDireccion",
      label: "Direccion",
      minWidth: 150,
      tipo: "string",
      propiedad: "empDireccion",
    },
    {
      id: "empTelefono",
      label: "Telefono",
      minWidth: 150,
      tipo: "string",
      propiedad: "empTelefono",
    },
    {
      id: "empIva",
      label: "Iva",
      minWidth: 150,
      tipo: "numero",
      propiedad: "empIva",
    },
    {
      id: "empIce",
      label: "Ice",
      minWidth: 150,
      tipo: "numero",
      propiedad: "empIce",
    },
  ];
  const [ObjectoActivo, setObjetoActivo] = useState({
    // empId: 3,
    empRuc: "",
    empNombre: "",
    empRepresentante: "",
    empComercial: "",
    empObligado: "",
    empDireccion: "",
    empTelefono: "",
    empTipo: "1",
    empIva: "12",
    empIce: "0",
    empCategoria: "CONTABLE",
    empEstado: "",
    empLogo: "",
    empFirma: "",
    empClavef: "",
    empCodigo: "",
    empRegimen: "",
    empFechaCaducaFirma: "",
    correoEnv: "",
    correoResp: "",
    empTipografia: "",
    empCopiaEmail: "",
    empPaginaWeb: "",
    empFacebook: "",
    empInstagram: "",
    empColor: "",
    empUser: "",
    empFecReg: "",
    empLeyenda: "",
    empProvincia: "SANTO DOMINGO DE LOS TSÁCHILAS",
    empCanton: "SANTO DOMINGO",
    empAgenteRetencion: "NO",
    empContribuyenteEspecial: "",
    empColorPrimario: "#2196f3",
    empColorSecundario: "#263238",
    empLogoRectangular: "",
    empRoles: [],
    empEstableciActivos: "0",
    empIdentificadorNumCelular: "0",
  });
  const [pagination, setpagination] = useState(null);
  // FUNCIONES STATE
  const getDataState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa
  ) => {
    const res = await clienteAxios.get(
      `/empresas/?cantidad=${cantidad}&page=${page}&search=${
        search ? search : ""
      }&input=${input ? input : ""}&orden=${orden ? orden : ""}&datos=${
        datos ? datos : ""
      }&rucempresa=${rucempresa ? rucempresa : ""}`
    );

    return res;
  };

  const obtenerState = async (
    cantidad = 10,
    page = 0,
    search,
    input,
    orden,
    datos,
    rucempresa
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
  };
  const addRowsState = async (items) => {
    setrows([...rows, ...items]);
  };
  const remplazarRowsState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
    // dispatch({
    //   type: OBTENER,
    //   payload: {
    //     results: res.data.data.results,
    //     pagination: res.data.data.pagination,
    //   },
    // });
  };
  const agregarState = async (item) => {
    try {
      setrows([item, ...rows]);

      setpagination({
        ...pagination,
        numRows: pagination.numRows + 1,
      });
    } catch (error) {}
  };

  const editarState = async (item) => {
    try {
      const resRows = rows.map((itemR) => {
        if (itemR.empId === item.empId) {
          return item;
        } else {
          return itemR;
        }
      });

      setrows(resRows);
    } catch (error) {}
  };

  const eliminarState = async (_id) => {
    try {
      const resRows = rows.filter((row) => {
        return row.empId !== _id;
      });
      setrows(resRows);
      setpagination({
        ...pagination,
        numRows: pagination.numRows - 1,
      });
    } catch (error) {}
  };
  const eliminarSeleccionState = async (_ids) => {
    const resRows = rows.filter((row) => {
      return !_ids.some((item) => {
        return item === row.empId;
      });
    });
    setpagination({
      ...pagination,
      numRows: pagination.numRows - _ids.length,
    });
    setrows(resRows);
  };

  const changeObjetoActivoState = (item) => {
    setObjetoActivo(item);
    // dispatch({
    //   type: CHANGE_ACTIVO,
    //   payload: item,
    // });
  };

  const rowsImportState = (rows) => {
    // dispatch({
    //   type: IMPORTAR_ROWS,
    //   payload: rows,
    // });
    setrows(rows);
  };
  // FIN FUNCIONES STATE
  // FIN DATA STATE

  // FUNCIONES SOCKET
  const [tabla] = useState("empresa");
  const [itemSocket, setitemSocket] = useState({
    tipo: "",
    item: {},
  });
  const socket = useRef();
  useEffect(() => {
    // Creates a WebSocket connection
    socket.current = io(socketUrl);
    socket.current.on("server:guardadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "agregar",
        item: data,
      });
    });
    socket.current.on("server:actualizadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "editar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitosoSeleccionado", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminarSeleccion",
        item: data,
      });
    });

    socket.current.on("server:error", (data) => {
      mostrarAlerta(
        data.msg ? data.msg : "Hubo un error",
        data.alert ? data.alert : "error"
      );
    });
    return () => {
      socket.current.disconnect();
    };
    // Destroys the socket reference
    // when the connection is closed
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const { item, tipo } = itemSocket;

    if (tipo === "") {
      return;
    }
    if (!rows) {
      return;
    }
    if (usuario.rucempresa !== item.rucempresa) {
      return;
    }
    if (item.tabla !== tabla) {
      return;
    }

    if (desdeOtroLugarMascota && Number(item.hcliMascId) !== idmascota) {
      return;
    }
    const funcionAalerta = () => {
      if (item.msg === "") {
        return null;
      }
      if (!item.msg) {
        return null;
      }
      mostrarAlerta(item.msg, item.alert ? item.alert : "success");
    };

    if (tipo === "agregar") {
      agregarState(item);
    }
    if (tipo === "editar") {
      editarState(item);
    }
    if (tipo === "eliminar") {
      eliminarState(item.empId);
    }
    if (tipo === "eliminarSeleccion") {
      eliminarSeleccionState(item.lista);
    }
    funcionAalerta();
    setitemSocket({ tipo: "", item: {} });
    // eslint-disable-next-line
  }, [itemSocket]);
  const { usuario } = useContext(AuthContext);
  const { mostrarAlerta } = useContext(AlertaContext);
  const [arrayExport, setarrayExport] = useState([]);
  const [campoExport] = useState("empId");
  const [open, setopen] = useState(false);
  const [buscando, setbuscando] = useState(false);
  const [editar, seteditar] = useState(false);
  const [search, setsearch] = useState("");
  const [cargando, setcargando] = useState(false);
  const [input, setinput] = useState({
    id: "empId",
    label: "ID",
    minWidth: 150,
    tipo: "string",

    propiedad: "empId",
  });
  const [orden, setorden] = useState(false);
  const [openMB, setopenMB] = useState(false);
  const [fullBuscador, setfullBuscador] = useState({
    empFecReg1: "",
    empFecReg2: "",
  });
  const {
    usuario: { rucempresa },
  } = useContext(AuthContext);
  //pagina actual
  const [page, setPage] = React.useState(0);
  //filas por pagina
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // input
  //
  const handleChange = (e) => {
    setfullBuscador({ ...fullBuscador, [e.target.name]: e.target.value });
  };
  const funcionB = async () => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa
    );

    setPage(0);
    setbuscando(true);
    setopenMB(false);
    setcargando(false);
  };

  const handleSearch = async () => {
    setcargando(true);
    setPage(0);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa
    );
    setcargando(false);
  };

  const funcionDefault = async () => {
    setcargando(true);
    setfullBuscador({
      empFecReg1: "",
      empFecReg2: "",
    });
    await remplazarRowsState(
      rowsPerPage,
      0,
      "",
      input.id,
      orden,
      JSON.stringify({
        empFecReg1: "",
        empFecReg2: "",
      }),
      rucempresa
    );
    setPage(0);
    setsearch("");
    setbuscando(false);
    setcargando(false);
    setopenMB(false);
  };

  return (
    <SocketProvider>
      <Box>
        <BarraTablas
          search={search}
          setsearch={setsearch}
          funcion={handleSearch}
          buscando={buscando}
          setbuscando={setbuscando}
          setopen={setopen}
          open={open}
          openMB={openMB}
          setopenMB={setopenMB}
          LabelBuscador={"Buscar"}
          ocultarBuscar={true}
          funcionDefault={funcionDefault}
          ocultarAgregar={true}
          ocultarOpciones={true}
        />{" "}
        <ModalB
          openMB={openMB}
          setopenMB={setopenMB}
          titulo={"Busqueda avanzada (Empresas)"}
          columns={columns}
          fullBuscador={fullBuscador}
          setfullBuscador={setfullBuscador}
          handleChange={handleChange}
          funcionB={funcionB}
          buscando={buscando}
          setbuscando={setbuscando}
        />
        <Tabla
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          search={search}
          input={input}
          orden={orden}
          setinput={setinput}
          setorden={setorden}
          seteditar={seteditar}
          setopen={setopen}
          rows={rows}
          buscando={buscando}
          cargando={cargando}
          setcargando={setcargando}
          fullBuscador={fullBuscador}
          // STATE
          addRowsState={addRowsState}
          getDataState={getDataState}
          remplazarRowsState={remplazarRowsState}
          obtenerState={obtenerState}
          pagination={pagination}
          columns={columns}
          ObjectoActivo={ObjectoActivo}
          changeObjetoActivoState={changeObjetoActivoState}
          rowsImportState={rowsImportState}
          // export
          arrayExport={arrayExport}
          setarrayExport={setarrayExport}
          campoExport={campoExport}
          socket={socket}
        />
        <Modal
          editar={editar}
          seteditar={seteditar}
          setopen={setopen}
          open={open}
          ObjectoActivo={ObjectoActivo}
          changeObjetoActivoState={changeObjetoActivoState}
          socket={socket}
        />
      </Box>
    </SocketProvider>
  );
};

export default memo(Asistencia);
